import styled from '@emotion/styled';

export const Spacer40 = styled.div`
  height: ${({ theme }) => theme.spacing[40]};
`;

export const Spacer50 = styled.div`
  height: ${({ theme }) => theme.spacing[50]};
`;
